import { Vector3 } from 'three';
import { useMemo } from 'react';

export default function useLerpedVector3(from: Vector3, to: Vector3, t: number): Vector3
{
  return useMemo(() => new Vector3().lerpVectors(from, to, t), [from, t, to]);
}